// extracted by mini-css-extract-plugin
export default {"card-primary":"CardPrimaryLarge_card-primary__ZFAdR","card-priimary":"CardPrimaryLarge_card-priimary__hcY-j"};